import axios from 'axios';
import { IDropdownItem } from 'src/interfaces';
import { ExportFileTypes } from '../constants/exportFilesConstants';
import { TUserWorkspace } from 'src/interfaces/workspacesReduxShapes';
import { SAVED_LAST_WS_KEY } from 'src/constants/workspacesConstants';
import { TSavedWorkspaceLocalStorage } from 'src/interfaces/WorkspacesTypes';

type Props = {
  fileType: ExportFileTypes;
  href: string;
  fileName: string;
};

export const onExport = ({ fileName, href, fileType }: Props): void => {
  const link = document.createElement('a');
  link.href = href;

  link.setAttribute('download', `${fileName}.${fileType}`);
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
};

export const exportFileApi = async (
  fileURL: string,
  fileName: string,
  fileType: string,
  accessToken: string
): Promise<void> => {
  const response = await axios.get(process?.env?.REACT_APP_BACKEND_URL + fileURL, {
    responseType: 'blob'
  });

  const data = response.data;

  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');

  link.href = url;
  link.setAttribute('download', `${fileName}.${fileType}`);

  document.body.appendChild(link);

  link.click();
  link.parentNode.removeChild(link);
};

export const getCurrentAllocation = (options: IDropdownItem[], selectedAllocation: IDropdownItem): IDropdownItem => {
  if (!options?.length) return null;

  return selectedAllocation;
};

export const setCurrentWorkspaceinLocalStorage = (workspace: TUserWorkspace, email: string): void => {
  const savedWorkspaces: TSavedWorkspaceLocalStorage = JSON.parse(localStorage.getItem(SAVED_LAST_WS_KEY) || '{}');

  localStorage.setItem(
    SAVED_LAST_WS_KEY,
    JSON.stringify({
      ...savedWorkspaces,
      [email]: workspace
    } as TSavedWorkspaceLocalStorage)
  );
};

export const getCurrentWorkspaceFromLocalStorage = (email: string): TUserWorkspace => {
  const saved = localStorage.getItem(SAVED_LAST_WS_KEY);

  if (saved) {
    try {
      const parsed = JSON.parse(saved) as TSavedWorkspaceLocalStorage;
      const emails = Object.keys(parsed) ?? [];

      if (emails.includes(email)) {
        const workspaceData = parsed[email] as TUserWorkspace;

        return workspaceData;
      }
    } catch (error) {
      console.error('Error parsing saved workspace from localStorage', error);
    }
  }

  return null;
};
